export default __webpack_public_path__ + "static/media/hbs-blk-poster-3.58904030.jpg";